import { Component, EventEmitter, Injectable, Input, OnInit, Output } from '@angular/core';
import { IRequest } from 'app/shared/Domains/request';
import { Configuration } from "config/config";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService, } from "primeng/api";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { IMemberFreezeDetail } from 'app/shared/Domains/memberFreezeDetail';
import { ICompany } from "app/shared/Domains/company";
import { IMemberContact } from "app/shared/Domains/memberContact";
import globalVariable from "../../../../globalVariable/globalVariable.json";
import { RequestStatus } from 'app/shared/enums/enums';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { IBranch } from 'app/shared/Domains/branch';
import { IVisitor } from 'app/shared/Domains/visitor';
import { AppUtils } from 'common/services/app.util';
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { visitorTypes } from 'app/shared/Domains/visitorTypes';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: 'app-visitor-request-detail',
    templateUrl: './visitor-request-detail.component.html',
    styleUrls: ['./visitor-request-detail.component.css']
})

export class VisitorRequestDetailComponent implements OnInit {

    @Input() requestor;
    @Output("reject") reject: EventEmitter<any> = new EventEmitter();
    visitor: IVisitor;
    loading: boolean;
    user: IUser;
    freezeMemberDetails: any[];
    errorExempleNumber: any;
    company: ICompany;
    branch: IBranch;
    date: any;
    freezeDetail: IMemberFreezeDetail;
    requestId: string;
    RequestStatus = RequestStatus;
    message: string;
    isSuccess: boolean;
    isError: boolean;
    activeIndex: number;
    isMessage: boolean;
    fund: IMemberFeeDetails;
    feeTotal: number;
    branchName: string;
    selectedBranch: any;
    companyImage: ICompany;
    visitorID: any;
    visitorFee: any;
    visitorTypes: any = [];
    selectedFees: any;
    defaultVisitorTypeName: visitorTypes;
    paymentOptions:any;
    paymentMode:string;
    selectedFeesObj: any = {};
    trainingBySomeoneElse: any;
    trainerName: string;
    allTrainers: any[];
    selectedTrainer: any;
    formattedNumber: string = '';
    taxType: string;
    mode: string;
    taxRate: number;
    visitorFeeTax: number = 0;
    hideTaxInfo: boolean = false;
    visitorFeeDiscount: any = 0;

    constructor(
        private LanguageService: LanguageService,
        private route: ActivatedRoute,
        public config: Configuration,
        private ConfirmationService: ConfirmationService,
        private router: Router,
        private messageService: MessageService,
        private appServiceManager: AppServiceManager,
        private breadcrumbService: BreadcrumbService
    ) {
        route.params.subscribe((params) => {
            this.requestId = params["id"];
            if (this.requestId !== undefined) {
                this.requestId = params["id"];
                this.getRequestByID();

            }
        });

    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("VisitorRequestDetailComponent", label);
      }
    ngOnInit() {
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;
        this.date = new Date();
        this.user = AuthService.getLoggedInUser();
        this.company = new ICompany();
        this.branch = new IBranch();
        this.getCompany();
        this.getBranch();
        this.getTrainers();
        this.visitor = new IVisitor();
        this.visitor.feeDetails = [];
        this.paymentMode="Cash-Reception";
        this.fund = new IMemberFeeDetails();
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;
    }
    InitObjects() {
        this.requestor = new IRequest();
        this.onSelect
    }

    getRequestByID() {
        this.loading = true;
        this.appServiceManager
            .get("customers/requests/" + this.requestId)
            .subscribe(
                (requestor: any) => {
                    this.requestor = requestor;
                    this.requestor.visitorFeeDiscount = 0;
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                }
            );
    }
    update(requestorForm: any) {
        if (requestorForm.valid) {
            const contact = this.requestor.contactDetail.contact;
            let payload = requestorForm.value;
            payload.contact = contact;
            payload['type'] = 'Visitor';
            this.appServiceManager
                .put("requests/" + this.requestId, payload)
                .subscribe(
                    (_res: any) => {
                        if (_res.status == true) {
                            // successfull message display issue
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Request Updated Successfully' });
                        } else {
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Visitor Updated Successfully' });
                        }
                    },
                    (error: any) => {
                        this.message = "Something went wrong ";
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: error,
                        });
                    }
                );
        }
        else {
            //  // Form validation error handling
            Object.keys(requestorForm.controls).forEach(controlName => {
                const control = requestorForm.controls[controlName];
                control.markAsTouched(); // Mark the control as touched to display the validation error messages
            });
        }
    }

    getCompany() {
        this.appServiceManager.get('companies/' + this.user.company).subscribe((res) => {
            if (res) {
                this.company = res;
            } else {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        },
            (error) => {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
    }

    getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.paymentOptions= [
                { label: 'Cash - Reception',  value: 'Cash-Reception' },
            ];

            let length;
            if (Array.isArray(this.branch.payments)) {
                length = this.branch.payments.length;
                this.taxType = this.branch.payments[length - 1].taxSettings.taxCalculationType;
                this.taxRate = this.branch.payments[length - 1].taxSettings.taxRate;
                const paymentModes = this.branch.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if (paymentModes.length == this.branch.payments.length) {
                    this.hideTaxInfo = true;
                }
                this.visitorTypes = this.branch.visitorTypes;
                this.visitorFee = this.visitorTypes[0].fees;
                if (this.taxType === 'WITH_TAX') {
                    this.visitorFeeTax = (this.visitorFee - this.visitorFeeDiscount) * this.taxRate / 100.0;
                } else {
                    this.visitorFeeTax = (this.visitorFee * this.taxRate) / 100;
                }
                this.selectedFeesObj = this.visitorTypes[0];
                this.branch.payments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
            }
            this.visitorTypes = this.branch.visitorTypes;
            const defaultIndex = this.visitorTypes.findIndex(type => type.name === this.requestor.visitorType);

             if (defaultIndex !== -1) {
             // Swap the elements at the 0th index and the index found
              [this.visitorTypes[0], this.visitorTypes[defaultIndex]] = [this.visitorTypes[defaultIndex], this.visitorTypes[0]];

             // Set the defaultVisitorTypeName to the swapped value
             this.defaultVisitorTypeName = this.visitorTypes[0];
         }
            this.selectedBranch = this.branch;
            // this.visitorFee = this.branch.visitorFee;
            // this.selectedFeesObj = this.visitorTypes[0];
            // if (Array.isArray(this.branch.payments)) {
            // this.branch.payments.forEach(payment => {
            //     const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
            //     if (!existingBank) {
            //     this.paymentOptions.push({
            //         label: `${payment.type} - ${payment.name}`,
            //         value: `${payment.type}-${payment.name}`
            //     });
            //     }
            // });
            // }
        }
        if(!this.branch){
        this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
            if (res) {
                this.branch = res;
                this.visitorTypes = res.visitorTypes;
                const defaultIndex = this.visitorTypes.findIndex(type => type.name === this.requestor.visitorType);
                let length;
                if (Array.isArray(this.branch.payments)) {
                    length = this.branch.payments.length;
                    this.taxType = this.branch.payments[length - 1].taxSettings.taxCalculationType;
                    this.taxRate = this.branch.payments[length - 1].taxSettings.taxRate;
                    const paymentModes = this.branch.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                    if (paymentModes.length == this.branch.payments.length) {
                        this.hideTaxInfo = true;
                    }
                    this.visitorTypes = this.branch.visitorTypes;
                    this.visitorFee = this.visitorTypes[0].fees;
                    if (this.taxType === 'WITH_TAX') {
                        this.visitorFeeTax = (this.visitorFee - this.visitorFeeDiscount) * this.taxRate / 100.0;
                    } else {
                        this.visitorFeeTax = (this.visitorFee * this.taxRate) / 100;
                    }
                    this.selectedFeesObj = this.visitorTypes[0];
                    this.branch.payments.forEach(payment => {
                        const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                        if (!existingBank) {
                            this.paymentOptions.push({
                                label: `${payment.type} - ${payment.name}`,
                                value: `${payment.type}-${payment.name}`
                            });
                        }
                    });
                }
                 if (defaultIndex !== -1) {
                 // Swap the elements at the 0th index and the index found
                  [this.visitorTypes[0], this.visitorTypes[defaultIndex]] = [this.visitorTypes[defaultIndex], this.visitorTypes[0]];

                 // Set the defaultVisitorTypeName to the swapped value
                 this.defaultVisitorTypeName = this.visitorTypes[0];
             }
                this.selectedBranch = res;
                // this.visitorFee = res.visitorFee;
                // this.selectedFeesObj = this.visitorTypes[0];
                // res.payments.forEach(payment => {
                //     const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                //     if (!existingBank) {
                //     this.paymentOptions.push({
                //         label: `${payment.type} - ${payment.name}`,
                //         value: `${payment.type}-${payment.name}`
                //     });
                //     }
                // });
            } else {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        },
            (error) => {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
    }

    get finalVisitorFee(): number {
        return this.requestor.visitorFee - this.requestor.visitorFeeDiscount;
    }

    setDefaultVisitorType() {
        if (this.defaultVisitorTypeName && this.visitorTypes.some(type => type.name === this.defaultVisitorTypeName.name)) {
          this.defaultVisitorTypeName = this.visitorTypes.find(type => type.name === this.defaultVisitorTypeName.name);
        } else {
          // Set a default value if needed
          this.defaultVisitorTypeName = this.visitorTypes[0];
        }
      }

    onSelect(event: any) {
        this.requestor.visitorType = event.value.name;
        this.selectedFeesObj = event.value;
        this.requestor.visitorFee = event.value.fees;
        // this.visitorFee = this.selectedFees;
        if (this.taxType === 'WITH_TAX') {
            this.visitorFeeTax = (this.requestor.visitorFee - this.requestor.visitorFeeDiscount || 0) * this.taxRate / 100.0;
        } else {
            this.visitorFeeTax = (this.requestor.visitorFee * this.taxRate) / 100;
        }
        this.calculateTotal();
    }

    rejectRequest() {
        this.reject.emit();
    }
    recalculateTax() {
        if (this.taxType === 'WITH_TAX') {
            this.visitorFeeTax = (this.requestor.visitorFee - this.requestor.visitorFeeDiscount) * this.taxRate / 100.0;
        } else {
            this.visitorFeeTax = (this.requestor.visitorFee * this.taxRate) / 100;
        }
    }


    approved() {
        this.ConfirmationService.confirm({
            message: "Are you sure you want to approved request ?",
            accept: () => {
                this.loading = true;
                this.appServiceManager
                    .post("customers/approveRegistration", this.visitor)
                    .subscribe(
                        (visitor) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Visitor Registration Approved Successfully",
                            });
                            setTimeout(() => {
                                this.router.navigateByUrl(
                                    "visitors/visitor/" + visitor._id
                                );
                            }, 300);
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "info",
                                summary: "Info Message",
                                detail: "Something Went Wrong",
                            });
                        }
                    );
            },
        });
    }

    async getVisitorByID() {
        try {
            const res: any = await this.appServiceManager.get("visitors/" + this.visitorID).toPromise();
            if (res) {
                this.visitor = res;
                this.visitor.date = new Date(this.visitor.date);
                if (this.visitor.dateOfBirth) {
                    this.visitor.dateOfBirth = new Date(this.visitor.dateOfBirth);
                }
                this.calculateTotal();
                this.breadcrumbService.setItems([
                    { label: 'Visitor Management' },
                    { label: 'All Visitors', routerLink: '/visitors' },
                    { label: this.visitor.name }
                ]);
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        } catch (error) {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        }
    }


    calculateTotal() {
        this.feeTotal = 0;
        if (this.visitor.feeDetails) {
            if (this.visitor.feeDetails.length > 0) {
                this.visitor.feeDetails.forEach((record) => {
                    this.feeTotal += parseInt(record.pay.toString());
                });
            }
        }
    }

    onPaymentModeChange(value: string) {
        this.paymentMode = value;
        const extractedValue = value.split("-")[1];
        if (Array.isArray(this.branch.payments)) {
            this.branch.payments.forEach(payment => {
                if (payment.name == extractedValue) {
                    this.taxType = payment.taxSettings.taxCalculationType;
                    this.taxRate = payment.taxSettings.taxRate;
                    if (this.taxType === 'WITH_TAX') {
                        this.visitorFeeTax = (this.requestor.visitorFee - this.requestor.visitorFeeDiscount) * this.taxRate / 100.0;
                    } else {
                        this.visitorFeeTax = (this.requestor.visitorFee - this.requestor.visitorFeeDiscount) * this.taxRate / 100.0;
                    }
                    this.fund.tax = this.visitorFeeTax; // Update the fund tax
                }
            });
        }
        this.calculateTotal(); // Recalculate the total
    }
    proceedForApproval(requestorForm: any) {
        if (requestorForm.valid) {
            this.visitor = Object.assign(this.visitor, requestorForm.value);
            delete this.visitor['visitorFee'];

            this.visitor.company = this.company._id;
            this.visitor.branch = this.branch._id;
            this.visitor.dayPass = this.requestor.visitorType;
            this.visitor.type = 'Visitor Signup';
            this.visitor.scope = 'Visitor';
            this.visitor.initiatedFrom = 'Add Visitor';
            this.visitor.activityBy = this.user.name;
            this.visitor.phone = this.requestor.contactDetail.contact;
            this.fund.taxRate = this.taxRate;
            this.fund.date = new Date(Date.now());
            this.fund.createdDate = new Date(Date.now());
            this.fund.createdBy = this.user.name;
            this.fund.tax = this.visitorFeeTax;
            // Calculate the final visitor fee after discount
            const discountAmount = requestorForm.value.visitorFeeDiscount || 0;
            this.recalculateTax();
            const originalFee = requestorForm.value.visitorFee || 0;
            if (this.taxType == 'WITH_TAX') {
                this.fund.pay = (originalFee - discountAmount) + this.visitorFeeTax; // Apply discount to the fee
            }
            else {
                this.fund.pay = (originalFee - discountAmount); // Apply discount to the fee
            }
            this.fund.discount = discountAmount;
            this.fund.dayPass = this.visitor.dayPass;
            this.fund.trainerName = this.trainerName;
            this.fund.paymentMode = this.paymentMode;
            this.fund.fee = originalFee;
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1;
            const currentYear = currentDate.getFullYear();
            this.fund.taxCalculationType = this.taxType;
            // this.visitor.feeDetails.push(this.fund);
            // this.fund.invoice = null;
            this.fund.invoice = AppUtils.generateInvoiceNo(this.visitor.name, this.visitor.feeDetails, currentYear, currentMonth, true);
            this.fund.status = "Visiting Fee - Paid";
            let data = {fund:this.fund,packageObj:this.selectedFeesObj};
            // this.visitor.feeDetails = [];
            this.appServiceManager.post("visitors", this.visitor).subscribe(async (res: any) => {
                if (res && res.status == true && !res.isAlreadyExist) {
                    this.calculateTotal();
                    requestorForm.reset();
                    this.visitorID = res.visitor._id;
                    this.isSuccess = true;
                    this.isError = false;
                    this.message = "Visitor has been added successfully.";
                    this.isMessage = true;
                    this.updateRequestStatus();
                    this.addFundDb(data);
                } else {
                    if (res.isAlreadyExist) {
                        this.visitorID = res.visitor._id;
                        await this.getVisitorByID();
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: "Visitor with same contact and name exists",
                        });
                        // this.calculateTotal();
                        setTimeout(() => {
                            this.router.navigateByUrl('visitors/visitor/' + this.visitorID);
                        }, 300);
                    }
                    else {
                        this.message = "Sorry, Something went wrong.";
                    }
                    this.isMessage = true;
                    this.isSuccess = false;
                    this.isError = true;
                }
            },
                (error: any) => {
                    this.isMessage = true;
                    this.message = "Something went wrong.";
                    this.loading = false;
                    this.isSuccess = false;
                    this.isError = true;
                });
        }
        else {
            //  // Form validation error handling
            Object.keys(requestorForm.controls).forEach(controlName => {
                const control = requestorForm.controls[controlName];
                control.markAsTouched(); // Mark the control as touched to display the validation error messages
            });
        }
    }
    getTrainers() {
        this.allTrainers = [];
        this.loading = true;
        this.appServiceManager
            .get(
                "users/company/" +
                this.user.company +
                "/branch/" +
                this.user.branch
            )
            .subscribe(
                (res) => {
                    if (res.length > 0) {
                        // this.trainerDropDown(res);
                        this.allTrainers = res;
                        this.allTrainers = res.filter(element => element?.role === 'Trainer');
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    onCheckboxChange() {
        if(this.trainingBySomeoneElse){
         this.trainingBySomeoneElse = false;
        }
        else{
         this.trainingBySomeoneElse = true;
        }
       }

       onConductedTrainerChange(event) {
        this.selectedTrainer= event.value;
        this.trainerName= this.selectedTrainer.name;
      }
    addFundDb(data) {
      this.appServiceManager.put("visitors/" + this.visitorID + "/payFund", data).subscribe((res: any) => {
        if (res) {
          this.visitor = res.visitor;
          setTimeout(() => {
            this.printInvoice();
          }, 200);
          setTimeout(() => {
            this.router.navigateByUrl('visitors/visitor/' + this.visitorID);
          }, 1000);
          this.visitor.date = new Date(this.visitor.date);
          if (this.visitor.dateOfBirth) {
            this.visitor.dateOfBirth = new Date(this.visitor.dateOfBirth);
          }
          this.calculateTotal();
          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Visitor Successfully Updated' });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }

    updateRequestStatus() {
        this.appServiceManager
            .post(`requests/${this.requestor._id}/approve/registration`, this.visitor)
            .subscribe(
                (member) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Visitor request has been approved successfully.",
                    });
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something went wrong",
                    });
                }
            );
    }

    updateRequestDetail() {
        throw new Error('Function not implemented.');
    }
    printInvoice(): void {
        let printContents: string, popupWin: Window;
        let currentDate = new Date();
        this.branchName = this.selectedBranch.name + " " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        printContents = document.getElementById('invoice').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
      <head>
          <title>${this.branchName}</title>
          <style>
              .invoice-box {
                  max-width: 800px;
                  margin: auto;
                  padding: 30px;
                  border: 1px solid #eee;
                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                  font-size: 16px;
                  line-height: 24px;
                  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                  color: #555;
              }
              .invoice-box table {
                  width: 100%;
                  line-height: inherit;
                  text-align: left;
              }
              .invoice-box table td {
                  padding: 5px;
                  vertical-align: top;
              }
              .invoice-box table tr td:nth-child(n + 2) {
                  text-align: right;
              }
              .invoice-box table tr.top table td {
                  padding-bottom: 20px;
              }
              .invoice-box table tr.top table td.title {
                  font-size: 45px;
                  line-height: 45px;
                  color: #333;
              }
              .invoice-box table tr.information table td {
                  padding-bottom: 40px;
              }
              .invoice-box table tr.heading td {
                  background: #eee;
                  border-bottom: 1px solid #ddd;
                  font-weight: bold;
              }
              .invoice-box table tr.details td {
                  padding-bottom: 20px;
              }
              .invoice-box table tr.item td {
                  border-bottom: 1px solid #eee;
              }
              .invoice-box table tr.item.last td {
                  border-bottom: none;
              }
              .invoice-box table tr.item input {
                  padding-left: 5px;
              }
              .invoice-box table tr.item td:first-child input {
                  margin-left: -5px;
                  width: 100%;
              }
              .invoice-box table tr.total td:nth-child(2) {
                  border-top: 2px solid #eee;
                  font-weight: bold;
              }
              .invoice-box input[type="number"] {
                  width: 60px;
              }
              @media only screen and (max-width: 600px) {
                  .invoice-box table tr.top table td {
                      width: 100%;
                      display: block;
                      text-align: center;
                  }
                  .invoice-box table tr.information table td {
                      width: 100%;
                      display: block;
                      text-align: center;
                  }
              }
              .rtl {
                  direction: rtl;
                  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                      sans-serif;
              }
              .rtl table {
                  text-align: right;
              }
              .rtl table tr td:nth-child(2) {
                  text-align: left;
              }
          </style>
      </head>
      <body>
          ${printContents}</body>
      </html>
      `
        );
    }
}

